module.exports = __webpack_public_path__ + "static/img/我的订单@3x.b5a3efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medical/index/我的订单@3x.png
// module id = 773
// module chunks = 358